import { render } from "./Pi.vue?vue&type=template&id=f61441aa&scoped=true"
import script from "./Pi.vue?vue&type=script&lang=js"
export * from "./Pi.vue?vue&type=script&lang=js"

import "./Pi.vue?vue&type=style&index=0&id=f61441aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f61441aa"

export default script